import { Address } from '@funnels/types';

export default function isAddressOnlyPostCode(addressObj: Address) {
  let isPropertyLocationUnknown = false;
  const { postcode, state, city, standard } = addressObj;
  const { level, streetName, streetNumber, streetType, unit } = standard || {};

  if (!!postcode && !!state && !!city && !level && !streetName && !streetNumber && !streetType && !unit) {
    isPropertyLocationUnknown = true;
  }

  return isPropertyLocationUnknown;
}
